import { render, staticRenderFns } from "./vVerify.vue?vue&type=template&id=2fc058bd"
import script from "./vVerify.vue?vue&type=script&lang=js"
export * from "./vVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports